export const FETCH_NEWS = 'news/FETCH_NEWS'
export const FETCH_NEWS_NEXT = 'news/FETCH_NEWS_NEXT'
export const RESET_STORE = 'news/RESET_STORE'
export const GET_NEWS_ARTICLE = 'news/GET_NEWS_ARTICLE'


